import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import NEW_API from "../../Api/NewApi";
import Button from "../Common/FormElements/Button/Button";

// One-shot modal: asks the SOFT back to generate a mobile-app magic-login
// link + QR code for the given customer (proxied to the app backend).
// Local async state on purpose — same convention as the other self-contained
// modals (the flow is a single POST with no shared state to keep).
const MagicLoginModal = ({ customer, onClose }) => {
  const { t } = useTranslation("common");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  useEffect(() => {
    let cancelled = false;
    NEW_API.post("/api/magic-login/generate", {
      userId: customer?.id,
    })
      .then(({ data }) => {
        if (!cancelled) setResult(data);
      })
      .catch((err) => {
        console.log(err);
        if (!cancelled) setError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [customer?.id]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(result?.url ?? "");
      toast.success(t("Link copied!"));
    } catch {
      toast.error(t("An error has occurred!"));
    }
  };

  return (
    <div className="fixed-top w-100 h-100 d-flex justify-content-center align-items-center zIndex-5">
      <div
        className="position-absolute w-100 h-100 bg-black bg-opacity-50"
        onClick={onClose}
      />
      <div className="position-relative bg-white br8 p-5 d-flex flex-column align-items-center gap-3 w35">
        <h3 className="quickSand bold text-blue f20">
          {t("Mobile app invitation")}
        </h3>
        <p className="f14 text-lightBlack text-center">
          {customer?.firstName} {customer?.lastName} — {customer?.email}
        </p>
        {loading ? (
          <p className="f14 text-lightBlack">{t("Loading...")}</p>
        ) : error ? (
          <p className="f14 text-red">{t("An error has occurred!")}</p>
        ) : (
          <>
            {result?.qrCodeSvg ? (
              <div
                className="magicLoginQr"
                style={{ width: 220, height: 220 }}
                dangerouslySetInnerHTML={{ __html: result.qrCodeSvg }}
              />
            ) : null}
            {/* <p className="f12 text-lightBlack text-center customScroll">
              {result?.url}
            </p> */}
            <p className="f12 text-lightBlack">
              {t("This link is valid for 15 minutes and can be used once.")}
            </p>
            <Button onClick={handleCopy}>{t("Copy the link")}</Button>
          </>
        )}
        <Button variant="outline" onClick={onClose}>
          {t("Close")}
        </Button>
      </div>
    </div>
  );
};

export default MagicLoginModal;
